import { data, sliderSettings } from "../data/carouselData";

import { MainHeroSection } from "./heroSectionElement";

import * as C from "components/common";

import HeroCardSlider from "./heroCardSlider";
import MainNavbar from "../navbar/mainNavbar";
import { useState } from "react";
import SecondaryNavbar from "components/navbar/secondaryNavbar";

type Props = {
  heroSectionContainer?: boolean;
};
const HeroSection: React.FC<Props> = () => {
  return (
    <MainHeroSection
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ delay: 0.15, duration: 1 }}
    >
      <SecondaryNavbar />

      <C.MainContainer heroSectionContainer>
        <C.MainSlider {...sliderSettings}>
          {data.map((item, index) => (
            <HeroCardSlider item={item} />
          ))}
        </C.MainSlider>
      </C.MainContainer>
    </MainHeroSection>
  );
};

export default HeroSection;
